/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Lot_NotesInputs */

const vi_sl_lot_notes = /** @type {(inputs: Sl_Lot_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi chú`)
};

/**

* @param {Sl_Lot_NotesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_lot_notes = /** @type {((inputs?: Sl_Lot_NotesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Lot_NotesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_lot_notes(inputs)
});